import React from "react";
import Select from "./common/Select.vue";
import { useDtfStore } from "./store";
import { useSpanglesStore } from "./spangles-module";
import "./DtfSpanglesColorSelector.scss";
import { renderList } from "common/vue/render-list";
import { cn } from "tailwind-variants";

export default function DtfSpanglesColorSelector(props) {
  const { ...restProps } = props;
  const store = useDtfStore();
  const spanglesStore = useSpanglesStore();

  function spangleColors() {
    return store.spangleColors;
  }

  function selectedVersion() {
    return spanglesStore.selectedVersion;
  }

  function allAPIsCompleted() {
    return spanglesStore.allAPIsCompleted;
  }

  function disabled() {
    return (
      !selectedVersion() ||
      selectedVersion()?.isLoading ||
      selectedVersion()?.error ||
      !allAPIsCompleted()
    );
  }

  function colorOptions() {
    return spangleColors().map(color => ({
      value: `[${color.rgbCode}]`,
      label: color.name,
      prefix: color.imageUrl,
      labelSuffix: color.spangleCode
    }));
  }

  function colorValues() {
    if (disabled()) {
      return [];
    }
    if (!selectedVersion() || !selectedVersion().spanglePagesInfo) {
      return [];
    }
    return Object.values(selectedVersion().spanglePagesInfo).filter(
      color => typeof color === "object"
    );
  }

  function changeColor(...args) {
    return spanglesStore.changeColor(...args);
  }

  function getColorValue({ color }) {
    return colorOptions().find(colorValue => colorValue.value === JSON.stringify(color));
  }

  function selectColor(index, color) {
    const values = colorValues();
    values[index] = {
      ...values[index],
      color: JSON.parse(color)
    };
    changeColor({
      colorValues: values.reduce(
        (acc, value, trayIndex) => ({
          ...acc,
          [`tray_${trayIndex}`]: value
        }),
        {}
      )
    });
  }

  const colorValuesList = colorValues();

  return (
    <>
      {colorValuesList.length > 0 ? (
        <div {...restProps} className={cn("spangle-color-selector scope-e57dfa67")}>
          <div className={cn("spangle-color-selector__header scope-e57dfa67")}>
            Select spangles colors
          </div>
          <div className={cn("spangle-color-selector__color-container scope-e57dfa67")}>
            {renderList(colorValuesList, (color, index) => (
              <div className={cn("spangle-color-selector__color scope-e57dfa67")} key={color.value}>
                <span className={cn("spangle-color-selector__color-number scope-e57dfa67")}>
                  Color #{index + 1}
                </span>
                <Select
                  className={cn("scope-e57dfa67")}
                  disabled={disabled()}
                  value={getColorValue(color)}
                  options={colorOptions()}
                  placeholder={"Select a color"}
                  onChange={e => {
                    selectColor(index, e);
                  }}
                  data-testid="select"
                />
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </>
  );
}
